import { COUNTRIES, COUNTRIES_INFO } from '@app/dashboard/constants/countries';
import { TCountry } from '../types/outerLayout/common';
import i18n from '@app/dashboard/i18n';

const INT_PHONE_NUM_REGEX = /^(?:\+\d{1,3}\s?)?\d{8,15}$/;
const EMAIL_PATTERN = `^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$`;

export const emailOrPhoneValidation = (country?: TCountry) => {
  let phoneRegex: RegExp;

  if (country) {
    const { min, max } = COUNTRIES_INFO[country].phone_number_length;
    const phonePattern =
      country === COUNTRIES.EGY
        ? `(010|011|012|015)\\d{${min - 3},${max - 3}}`
        : `\\d{${min},${max}}`;
    phoneRegex = new RegExp(`^${phonePattern}$`);
  } else {
    phoneRegex = INT_PHONE_NUM_REGEX;
  }

  return {
    pattern: new RegExp(`(^${EMAIL_PATTERN}$)|(${phoneRegex.source})`),
    get error_msg() {
      return i18n.t('errors.invalidEmailOrPhone');
    },
  };
};
